import { render } from "./whiteCardModal.vue?vue&type=template&id=3c90a5d8"
import script from "./whiteCardModal.vue?vue&type=script&lang=js"
export * from "./whiteCardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__